import $ from 'jquery';

/**
 * 案件ごとの設定データに関する処理を纏めたクラス
 */
export default class EFOcats_settingdata {
  /**
   * efocats_read.phpからJSONデータ読込み
   * @param id ID
   * @param form_id フォームID
   * @returns 読み込んだデータ
   */
  async load(id, form_id) {
    try {
      const json = await $.ajax({
        url: 'https://formcats.com/efocats/efocats_read.php',
        datatype: 'json',
        type: 'POST',
        data: {
          ID: id,
          formID: form_id,
        },
        timeout: 5000,
      });

      if (json.error) {
        throw json.error;
      }

      return json;
    } catch (error) {
      throw 'efocats_read fail';
    }
  }

  /**
   * JSONデータを編集する
   * @param data 読み込んだデータ
   * @param formQuery 元フォームを取得するためのクエリ
   * @returns 編集したデータ
   */
  edit(data, formQuery) {
    data.form.label = [];

    // 指定したIDのフォームを取得
    const form = document.querySelector(formQuery);

    if (this.check(form)) {
      const pages = this.get_pages(form);

      // ページ単位で処理
      pages.forEach(page => {
        const temp = {
          question: this.get_text(page),
          answer: [],
        };

        const tpl = this.get_tpl(page);
        const input = this.get_inputs(page);

        if (input[0].type === 'radio' || input[0].type === 'checkbox') {
          // radio、チェックボックスの場合
          this.get_radio_checkbox(page, input, temp);
        } else {
          // radio、チェックボックスの以外場合
          this.get_radio_checkbox_other(page, input, temp);
        }

        // フリーテキスト
        this.get_free_text(page, temp);

        const lastOBj = {};
        lastOBj[tpl] = temp;

        data.form.label.push(lastOBj);
      });
    }

    return data;
  }

  /**
   * 処理を実行するかどうかを判断する
   * @param {*} form
   * @returns trueなら処理を実行する
   */
  check(form) {
    return form && form.localName === 'form';
  }

  /**
   * 入力欄をページごとに振り分ける
   * @param {*} form
   * @returns ページリスト
   */
  get_pages(form) {
    /*
     * ここでは1ページに１つの入力欄を振り分けている
     * ほとんどの案件ではこのままでは使えないので、案件ごとに子クラスで上書きをすること
     */

    const pages = [];
    const inputs = form.querySelectorAll('input,select,textarea');

    for (let index = 0; index < inputs.length; index++) {
      pages.push(inputs[index]);
    }

    return pages;
  }

  /**
   * 設問テキストを取得する
   * @param {*} page
   * @returns 設問テキスト
   */
  get_text(page) {
    // 案件ごとに子クラスで上書きをする
    return '';
  }

  /**
   * テンプレート名を取得する
   * @param {*} page
   * @returns テンプレート名
   */
  get_tpl(page) {
    // 案件ごとに子クラスで上書きをする
    return 'set-base';
  }

  /**
   * 必須かどうかを取得する
   * @param {*} page
   * @returns 必須なら1、そうでないなら0
   */
  get_required(page) {
    // 案件ごとに子クラスで上書きをする
    return 0;
  }

  /**
   * ページ内の入力欄を一通り取得する
   * @param {*} page
   * @returns 入力欄リスト
   */
  get_inputs(page) {
    // 案件ごとに子クラスで上書きをする
    const inputs = [];
    inputs.push(page);
    return inputs;
  }

  /**
   * ラジオボタンとチェックボックスを取得する
   * @param {*} input
   * @param {*} temp
   */
  get_radio_checkbox(page, input, temp) {
    const valueList = {};
    const nameList = [];
    const typeList = {};

    for (let k = 0, l = input.length; k < l; k++) {
      // valueをname別に収集
      if (!valueList[input[k].name]) {
        valueList[input[k].name] = [];
      }

      const tempval = {};
      tempval[input[k].value] = input[k].parentNode.textContent;

      tempval[input[k].value] = tempval[input[k].value].replace('可', 'はい').replace('否', 'いいえ');

      valueList[input[k].name].push(tempval);

      // nameを収集
      if (nameList.indexOf(input[k].name) === -1) nameList.push(input[k].name);

      // typeもnameに合わせる
      typeList[input[k].name] = input[k].type;
    }

    for (let k = 0, l = nameList.length; k < l; k++) {
      const tempanswer = {
        type: typeList[nameList[k]] || input[0].type,
        name: nameList[k],
        'data-required': String(this.get_required(page)),
        value: valueList[nameList[k]] || [],
      };

      // 属性設定
      this.get_attr(page, input, k, tempanswer);

      temp.answer.push(JSON.parse(JSON.stringify(tempanswer)));
    }
  }

  /**
   * ラジオボタンとチェックボックス以外を取得する
   * @param {*} input
   * @param {*} temp
   */
  get_radio_checkbox_other(page, input, temp) {
    for (let k = 0, l = input.length; k < l; k++) {
      const tempanswer = {
        type: this.get_type(input, k),
        name: input[k].name,
        'data-required': String(this.get_required(page)),
      };

      if (tempanswer.type === 'select') {
        tempanswer.value = [];
        const option = input[k].querySelectorAll('option');
        for (let n = 0; option.length > n; n++) {
          const tempval = {};
          tempval[option[n].value] = option[n].text;
          tempanswer.value[n] = tempval;
        }
      }

      // 属性設定
      this.get_attr(page, input, k, tempanswer);

      temp.answer.push(tempanswer);
    }
  }

  /**
   * タイプを取得する
   * @param {*} inputs
   * @param {*} index
   * @returns タイプ
   */
  get_type(inputs, index) {
    return inputs[index].localName === 'select' || inputs[index].localName === 'textarea' ? inputs[index].localName : inputs[index].type;
  }

  /**
   * フリーテキストを取得する
   * @param {*} page
   * @param {*} temp
   * @returns フリーテキスト
   */
  get_free_text(page, temp) {
    // 案件ごとに子クラスで上書きをする
    return '';
  }

  /**
   * 属性を取得する
   * @param {*} page
   * @param {*} inputs
   * @param {*} index
   * @param {*} tempanswer
   */
  get_attr(page, inputs, index, tempanswer) {
    if (page.indexOf('電話番号') >= 0) {
      tempanswer.maxlength = 11;
    }
  }
}
